(ns frontend.ui.component.lp-portal.stacked-text-group.style)

(defn stacked-text-group
  []
  {:padding "8px 0px 12px"})
